module.exports = __webpack_public_path__ + "img/activity.8f5f96bf.svg";